import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { TitleChange } from '../services/title-change';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-paul',
  imports: [Link, RouterLink],
  templateUrl: './paul.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './paul.scss',
})
export class Paul {
  dynamicTitle = inject(TitleChange);
  constructor() {
    this.dynamicTitle.title(`Paul`);
    this.dynamicTitle.description(`Paul is a result of epistolary fiction and all of the letters are pseudepigraphical.`);
  }
}
